import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MainMenuModule } from '../main-menu/main-menu.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoriesModule } from '../categories/categories.module';
import { AppRoutingModule } from '../../app-routing.module';
import { ChildcategoryComponent } from './childcategory.component';
import { ParentCardModule } from '../parent-card/parent-card.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ChildcategoryComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    MatSliderModule,
    MainMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    CategoriesModule,
    ParentCardModule,
    MatSnackBarModule,
    RouterModule
  ],
  exports: [
    ChildcategoryComponent,
    RouterModule
  ]
})
export class ChildcategoriesModule { }
